import React from "react";
import { motion } from "framer-motion";
import { PartyPopper, Share2 } from "lucide-react";
import { STATS } from "../../lib/winners";

const rise = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.7, delay: d, ease: [0.22, 1, 0.36, 1] } });

export function WinnersHero({ onCelebrate, onShare }) {
  return (
    <section className="relative mx-auto w-full max-w-6xl px-4 pb-10 pt-10 md:pb-16 md:pt-16" data-testid="winners-hero-banner">
      <motion.img {...rise(0.3)} src="/assets/winners/ubot-back.webp" alt="" aria-hidden="true"
        className="pointer-events-none absolute -left-10 bottom-0 hidden w-56 opacity-80 lg:block xl:-left-20 xl:w-72" />
      <div className="relative flex flex-col items-center text-center">
        <motion.img {...rise(0)} src="/assets/winners/logo-uhackathon.webp" alt="u-hackathon" className="h-8 w-auto md:h-10" />
        <motion.p {...rise(0.08)} className="mt-3 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-sky-500 sm:text-[11px] sm:tracking-[0.35em]">Bangkok · 2026 · Results are in</motion.p>
        <motion.h1 {...rise(0.16)} className="mt-5 font-display text-[64px] font-extrabold uppercase leading-[0.82] text-white sm:text-[96px] lg:text-[128px]">
          Winners
          <span className="block bg-gradient-to-r from-gold-200 via-gold-400 to-gold-600 bg-clip-text text-transparent">Showcase</span>
        </motion.h1>
        <motion.p {...rise(0.24)} className="mt-5 max-w-md text-[16px] text-on-dark-muted md:text-[18px]">
          Six teams. Two tracks. One unforgettable weekend. Meet the builders who took the stage, then go back them.
        </motion.p>
        <motion.div {...rise(0.32)} className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <button onClick={onCelebrate} data-testid="celebrate-confetti-btn"
            className="inline-flex h-12 items-center gap-2 rounded-pill bg-gold-500 px-6 font-display text-[17px] font-bold text-navy-950 shadow-gold-glow transition-transform hover:bg-gold-400 active:scale-95">
            <PartyPopper size={18} /> Celebrate
          </button>
          <button onClick={onShare} data-testid="winners-share-btn"
            className="inline-flex h-12 items-center gap-2 rounded-pill border border-white/20 px-5 font-semibold text-white transition-colors hover:bg-white/10">
            <Share2 size={16} /> Share
          </button>
        </motion.div>
        <motion.div {...rise(0.4)} className="mt-10 grid w-full max-w-lg grid-cols-3 divide-x divide-white/10 rounded-2xl bg-white/[0.04] ring-1 ring-white/10 backdrop-blur-xl" data-testid="winners-stats">
          {STATS.map((s) => (
            <div key={s.label} className="px-2 py-4">
              <p className="font-mono text-[28px] font-extrabold leading-none text-white md:text-[36px]">{s.value}</p>
              <p className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-sky-500">{s.label}</p>
            </div>
          ))}
        </motion.div>
      </div>
      <motion.img {...rise(0.2)} src="/assets/winners/ubot-front.webp" alt="U-Bot, the U-Hackathon mascot, waving"
        className="winners-float pointer-events-none mx-auto mt-6 w-40 lg:absolute lg:-right-6 lg:bottom-0 lg:mt-0 lg:w-64 xl:-right-16 xl:w-80" />
    </section>
  );
}
